export default __webpack_public_path__ + "static/media/icon_histsolicitacoes_gray.a5721ff7.svg";